<p>
  Welcome to your secret profile token: {{uid}}!
</p>
<button (click)="signOut()">Sign Out</button>